import "./styles.css";

interface IButtonAXS {
  onClick: (e:any) => void;
  textButton: string;
  type: any;
  disabled: any;
  id: any;
}

const buttonAXS: React.FC<IButtonAXS> = ({ onClick, textButton,type,disabled,id }) => {
  return (
          <button 
            className={"button-AXS"}
            onClick={onClick}
            type={type}
            disabled={disabled}
            id={id}
          >
          {textButton}
        </button>
  );
};
export default buttonAXS;
